import React from 'react';
import ReactDOM from 'react-dom';
import AppProvider from './AppProvider';
import FaqsContent from '../src/content/Faqs';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('faq-component');
  const data = JSON.parse(node.getAttribute('data'));

  ReactDOM.render(
    <AppProvider data={data}>
      <FaqsContent />
    </AppProvider>,
    document.getElementById('faq-component')
  )
});
